import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { detect } from 'detect-browser';

import NotFound from './NotFound';
import Page from './Page';

import '../style/App.css';

const App = (props) => {

	const browser = detect();

	if (browser && browser.name === 'internet explorer' && browser.version < 11) {
		return <div>This browser is not supported. Please catch up with the 21st century</div>;
	}

	return (
		<div className="container-fluid app">
		<Router>
			<Switch>
				<Route exact path="/:uid" render={routeProps => <Page {...routeProps} prismicCtx={props.prismicCtx} />} />
					<Route exact path="/" render={routeProps => <Page {...routeProps} prismicCtx={props.prismicCtx} />} />
				<Route component={NotFound} />
			</Switch>
		</Router>
		</div>
	);
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js